import React, { useRef } from 'react';
import { IStore } from '../../../../../redux/store';
import { Dispatch } from 'redux';
import { TBFL2HistoryFilters } from '../../../../../redux/app/bfl-2/@types';
import { ConnectedProps, connect } from 'react-redux';
import { useOnScrollToTop } from '../../../../../hooks/useScrollToTop';
import { marpolSelectors } from '../../../../../redux/app/marpol';
import BFL1CoverPage from './BFL1CoverPage';
import BFL1Print from './BFL1Print';
import { bfl1Actions, bfl1Selectors } from '../../../../../redux/app/bfl-1';

type OwnProps = {
    showCoverPages?: boolean;
	vesselId: string;
};
type BFL1HistoryProps = PropsFromRedux & OwnProps;

function BFL1InspectorView(props: BFL1HistoryProps) {
    const { historyList, showCoverPages, tanks, vesselId } = props;
    const topDivRef = useRef<HTMLDivElement | null>(null);
    useOnScrollToTop(topDivRef);

    return (
        <div>
            <div className="h-0" ref={topDivRef} />
            {showCoverPages ? (
                <BFL1CoverPage vesselId={vesselId}>
                    <div className="flex justify-center">
                        <h3 className="w-3/4 mb-6 text-base font-medium leading-5 tracking-wide text-gray-600">
                            PART II - Monitoring of biofouling risk parameters
                        </h3>
                    </div>
                </BFL1CoverPage>
            ) : null}

            <div className="py-4 newpage">
                <BFL1Print
                    key={'temp-print-id-bfl1'}
                    isPrintVisible={true}
                    bfl1Records={historyList}
					vesselId={vesselId}
                />
            </div>
        </div>
    );
}

function mapStateToProps(store: IStore, ownProps: OwnProps) {
    const biofoulingRecordStore = bfl1Selectors._getStore(store);
    const marpolStore = marpolSelectors._getStore(store);
    const tanks = marpolSelectors.getTanks(marpolStore);

    return {
        historyList: bfl1Selectors.getHistoryList(biofoulingRecordStore),
        jobToLoadHistory: bfl1Selectors.jobToLoadHistory(biofoulingRecordStore),
        tanks,
    };
}
function mapDispatchToProps(dispatch: Dispatch, ownProps: OwnProps) {
    return {
        load(filters: TBFL2HistoryFilters) {
            return dispatch(bfl1Actions.commands.historyLoad(filters));
        },
    };
}
const reduxConnector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof reduxConnector>;
export default reduxConnector(BFL1InspectorView);
